import slice from './reducer'
import newOwnersSaga from './sagas'

export const {
  fetchRequest: newOwnersRequest,
  fetchSuccess: newOwnersSuccess,
  fetchError: newOwnersError,

  updateFilters: newOwnersFilters,
  reset: newOwnersReset,

  fetchApproverHandlerRequest,
  fetchApproverHandlerSuccess,
  fetchApproverHandlerError,

  fetchYearlyApprovalsRequest,
  fetchYearlyApprovalsSuccess,
  fetchYearlyApprovalsError,
} = slice.actions

export default slice.reducer
export { newOwnersSaga }
